export default {
	currency: 'AED',
	underConstruction: {
		header: 'Page Under Construction',
	},
	axios: {
		unauthorized: 'Unauthorized: Access to this resource denied',
		fault: 'Something happen wrong, please contact administrator',
	},
	404: {
		header: '404',
		subHeader: "It's look like you are lost",
	},
	header: {
		searchPlaceHolder: 'Search...',
		navigation: {
			home: 'Home',
			auctions: 'Auctions',
			about: 'About',
			faqs: 'FAQs',
			contactUs: 'Contact Us',
		},
		auth: {
			login: 'Login',
			register: 'Join Free',
		},
		contact: {
			call: 'Call us anytime',
			fullLocation: 'Visit our office',
			smallLocation: 'Visit our office',
		},
		button: {
			joinUs: 'Join Free',
			login: 'Login',
			logOut: 'Log Out',
		},
	},
	footer: {
		button: {
			subscribe: 'Subscribe',
		},
		auctions: {
			name: 'Auctions',
			items: {
				title1: 'Abu Dhabi Number Plates',
				title2: 'Sharjah Number Plates',
				title3: 'Dubai Number Plates',
				title4: 'RAK Number Plates',
				title5: 'Ajman Number Plates',
				title6: 'Vehicles',
				title7: 'Machinery',
				title8: 'Dubai Property',
				title9: 'Abu Dhabi Property',
				title10: 'Etisalat VIP Plans',
				title11: 'General Items',
				title12: 'Charity',
			},
		},
		company: {
			name: 'The Company',
			items: {
				title1: 'About Emirates Auction',
				title2: 'How we started',
				title3: 'FAQs',
				title4: 'Contact Us',
			},
		},
	},
	login: {
		sectionTitle: 'Middle East’s largest auction platform',
		form: {
			emailOrUsername: 'Email or Username',
			password: 'Password',
			keepMe: 'Keep me logged in',
			submitButton: 'Login',
		},
		troubleLink: 'Forget your password?',
		signupNote: 'Don’t have an account?',
		signupButtton: 'Join Free',
	},
	home: {
		introSection: {
			headerTitle: 'Welcome to Middle East’s largest auction platform.',
			headerSecondTitle:
				'We have auctioned over 100,000 vehicles, 4500 properties',
			headerSecondSubTitle: 'and millions of other stuff.',
			buttonBiddingText: 'Start Bidding Now',
			buttonGoogle: 'Google Play',
			buttonApple: 'App Store',
			headerDownload: 'Our apps are available on',
		},
		categorySection: {
			title: 'Choose from over 500 items across 7 categories',
			subTitle:
				'We have auctioned over 100,000 vehicles, 4500 properties and millions of other stuff.',
		},
		partners: {
			title: 'Bid with confidence',
			description:
				'Emirates Auction is Middle East’s largest auction marketplace having successfully auctioned over 800,000 items till date.',
			carsAuctioned: 'Cars Auctioned',
			happyCustomers: 'Happy Customers',
			guinnessWorldRecords: 'Guinness World Records',
			appDownloads: 'App Downloads',
			raisedForCharity: 'Raised for Charity',
		},
		howItWorks: {
			title: 'How it works',
			description:
				'It’s extremely simple. Just join, set your bidding limit and start bidding.',
			tabs: [
				{
					tabTitle: 'Set your bidding limit',
					tabDescription:
						'For all auctions except properties the security deposit can be made by any of the following methods:\n' +
						'\n' +
						'\n' +
						'Credit card through our mobile application or website.\n' +
						'Bank transfer or deposit to our account.\n' +
						'Submit us a security cheque to any of our branches. \n' +
						'\n' +
						'\n' +
						'For Properties Auction the security deposit must be made by any of the following methods:\n' +
						'\n' +
						'\n' +
						'Managers cheque handed at any of Emirates Auction branches across UAE during the relevant working hours.\n' +
						'Bank transfer or deposit to our bank account.',
				},
				{
					tabTitle: 'Start bidding on items',
					tabDescription:
						'Cras porta tincidunt massa, id hendrerit dui rutrum scelerisque. Nullam scelerisque.',
				},
				{
					tabTitle: 'Checkout your winning bids',
					tabDescription:
						'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ultricies lectus interdum, mollis magna maximus, vestibulum ipsum.',
				},
			],
		},
		faq: {
			title: 'Have questions?',
			subTitle:
				'Here are some the most common FAQs. You can get in touch with one of our team members.',
			viewAll: 'View All FAQs',
			callUsTitle: 'Still in doubt?',
			callUsSubTitle: 'Call our 24hr hotline :',
		},
	},
	main: {
		componentLoading: 'Loading...',
	},
	register: {
		heading: 'Join Free & Start Bidding!',
		description: 'Kindly fill in your details below to register',
		acceptTerms: 'I accept the ',
		termsAndCond: 'terms & conditions',
		buttonContinue: 'Continue',
		otp: 'You will recieve an OTP on this number for verification',
		select: 'Select Country',
		fullName: 'Full Name',
		password: 'Password',
		userName: 'User Name',
		email: 'Email Address',
		mobile: 'Mobile Number',
		required: 'this filed is required',
		passwordError:
			'your password must conatain one special character and at least 8 digit',
	},
	bidInfo: {
		bid: 'Your bid',
		autoBid: 'Your Auto bid',
		highest: 'is currently leading.',
		hasBid: 'has been outbidded.',
		currency: 'AED',
	},
	vehicles: {
		filter: {
			searchPlaceHolder: 'Search',
			title: 'Filters',
			resetFilter: 'Reset All Filters',
			listing: {
				title: 'Listing Type',
				vehiclesRadioBtn: 'Vehicles',
				machineryRadioBtn: 'Machinery',
			},
			condition: {
				title: 'Condition',
				newConditionCheckBoxBtn: 'New',
				usedConditionCheckBoxBtn: 'Used',
				scrapConditionCheckBoxBtn: 'Scrap',
			},
			make: {
				title: 'Make',
			},
			model: {
				title: 'Model',
			},
			price: {
				title: 'Price Range (AED)',
			},
			year: {
				title: 'Year',
			},
			km: {
				title: "KM's",
			},
			search: {
				title: 'Search',
			},
			showResult: 'Show {count} Results',
		},
	},
	auth: {
		otp: {
			title: 'Join Free & Start Bidding!',
			subTitle1: 'We have sent you an sms with code to ',
			subTitle2:
				'	To complete your phone number verification please enter the 7 digit activation code',
			enterCode: 'Enter Code Here',
			resendCode: 'Resend the Code',
			changePhone: 'Change Phone Number',
			activeOTP: 'Active',
		},
	},
	carDetails: {
		specifications: {
			specifications: 'SPECIFICATIONS',
			make: 'Make',
			model: 'Model',
			year: 'Year',
			keys: 'Keys',
			extColor: 'Exterior',
			doors: 'Doors',
			transmission: 'Transmission',
			odometer: 'Odometer',
			fuel: 'Fuel Type',
			vin: 'Vin',
			trim: 'Trim',
			horsePower: 'HorsePower',
		},
		documents: {
			documents: 'DOCUMENTS',
			willBeReadyIn: 'Will be ready in ',
			view: 'View',
		},
		options: {
			options: 'Options',
		},
		briefInformation: {
			stop: 'Stop My Auto Bid At Current Price',
			confirmStop: 'Are your sure you want to stop auto-bid?',
			stopAutoBid: 'Auto Bid upto',
			lot: 'Lot',
			bids: 'Bids',
			odometer: 'Odometer',
			timeLeft: 'Time Left',
			addToCalender: 'Add to Calender',
			currentPrice: 'Current Price',
			minIncrement: 'Min. Increment',
			bidNow: 'Bid Now',
			confirmBid: 'Confirm Bid',
			availableLimit: 'Available Limit',
			addLimit: 'You need to add Deposit Limit for this type.',
			signIn: 'Sign In to place a bid.',
			termsAgreement:
				'I agree to Terms and Conditions & I have inspected the item',
			autoBid: 'Auto Bid',
			errors: {
				exceedLimit: "You don't have enough limit to bid",
				belowMinBidValue: 'Value should exceed the minimum Bid value',
				notMultiplesMinIncreasing:
					'The increasing value should be multiples of minimum increasing value',
			},
			warning: {
				exceedBidAmout:
					'You bid Amount is greater than Current price + (min increment*5) , are you sure you want to continue?',
			},
		},
		paymentDetails: {
			paymentDetails: 'PAYMENT DETAILS',
		},
		terms: {
			title: 'TERMS & CONDITIONS',
			termsList: [
				{
					body:
						'1. Note that the rules and regulations contained in this agreement can not be used against the ' +
						'"Emirates Auction," but due to it such as the Convention governing the relationship between all' +
						' relevant parties the site, note that any ambiguity in a regulation or a misunderstanding can not' +
						' be refuted in a negative impact on the interest of any of the parties. Can not resort to ' +
						'any regulations or laws other than regulations and laws set forth by the "Emirates Auction," ' +
						'below, but the event occurred Executive Director of the company confirms its commitment to ' +
						'the regulations and other laws, note that any agreement is signed by the authorized official, ' +
						'either verbally or in writing, not necessary to "Emirates Auction" any responsibilities ' +
						'or legal obligations. Recommend "Emirates Auction," all participants and members to ' +
						'read the regulations and laws governing its relationship with its customers, ' +
						'since customers are to continue the registration process, including approval of ' +
						'all of the Provisions of the regulations of the laws of nature proceed with the ' +
						'relationship between the parties.',
				},
			],
		},
		faqs: {
			title: 'FREQUENTLY ASKED QUESTION',
		},
	},
	vehicleDetails: {},
	stillHaveQuestions: {
		title: 'STILL HAVE QUESTIONS?',
		description:
			'Don’t worry! Just send us your enquiries and we will get back to you within 48 hours.',
	},
	form: {
		fullName: 'Full Name',
		email: 'Email Address',
		mobile: 'Mobile Number',
		enquiry: 'Enquiry',
		submit: 'Submit',
	},
	plans: {
		filter: {
			type: {
				title: 'Filter by Package Type',
				all: 'All',
				silver: 'Silver',
				gold: 'Gold',
				platinum: 'Platinum',
				diamond: 'Diamond',
			},
			price: {
				title: 'Price Range (AED)',
			},
			button: {
				subtitle1: 'Show',
				subtitle2: 'Results',
			},
		},
	},
	simDetails: {
		package: {
			planPackageHelper:
				'Package can be activated with either of the plans below',
			flexible: 'Flexible',
			local: 'Local',
			applicable: 'Applicable',
			notApplicable: 'Not Applicable',
		},
		branches: {
			panelTitle: 'E.A. BRANCH',
			panelDescription:
				'Once you win the bid, you will have the option to get the item delivered to you for an additional cost.',
			locationTitle: 'DELIVERY LOCATION',
			branchTimings: 'Branch Timings',
		},
	},
	plates: {
		info: {
			viewOnMyCar: 'View on My Car',
			long: 'Long',
			short: 'Short',
		},
		filter: {
			type: {
				title: 'VIP Plan Type',
				all: 'All',
				threeDigits: '3 Digits',
				fourDigits: '4 Digits',
				fiveDigits: '5 Digits',
			},
			price: {
				title: 'Price Range (AED)',
			},
			button: {
				subtitle1: 'Show',
				subtitle2: 'Results',
			},
		},
		details: {
			delivery: {
				title: 'DELIVERY',
				description:
					'Once you win the bid, you will have the option to get the item delivered to you for an additional cost.',
			},
			terms: {
				title: 'TERMS & CONDITIONS',
				termsList: [
					{
						body:
							'1. Note that the rules and regulations contained in this agreement can not be used against the ' +
							'"Emirates Auction," but due to it such as the Convention governing the relationship between all' +
							' relevant parties the site, note that any ambiguity in a regulation or a misunderstanding can not' +
							' be refuted in a negative impact on the interest of any of the parties. Can not resort to ' +
							'any regulations or laws other than regulations and laws set forth by the "Emirates Auction," ' +
							'below, but the event occurred Executive Director of the company confirms its commitment to ' +
							'the regulations and other laws, note that any agreement is signed by the authorized official, ' +
							'either verbally or in writing, not necessary to "Emirates Auction" any responsibilities ' +
							'or legal obligations. Recommend "Emirates Auction," all participants and members to ' +
							'read the regulations and laws governing its relationship with its customers, ' +
							'since customers are to continue the registration process, including approval of ' +
							'all of the Provisions of the regulations of the laws of nature proceed with the ' +
							'relationship between the parties.',
					},
				],
			},
		},
		physical: {
			startAt: 'Auction starts at',
			addToCalender: 'Add to calendar',
			registerForEvent: 'Register for Event',
			location: 'Location',
			viewOnMyCar: 'View on Car',
		},
	},
	plateModal: {
		header: 'Please Select Plate Emirate',
	},
	shoppingCart: {
		title: 'Shopping Cart Summary',
		subtotal: 'Subtotal',
		checkout: 'Checkout',
	},
	myDeposits: {
		notAvailable: 'Not Available',
		requestRefund: 'Request Refund',
		increaseLimit: 'Increase Limit',
		subHeader: 'Select one of the deposit method’s to proceed',
		cancelAndBack: 'Cancel & back to deposit dashboard?',
		refundCreditCardTitle: 'Request Refund by Credit Card',
		refundCreditCardSubHeader:
			'Amounts blocked on credit cards will be automatically released after 14 days.',
		noCreditCardDeposit: 'No Credit Card Deposit Currently Exist',
		refundChequeTitle: 'Request Refund by cheque',
		refundChequeSubHeader: 'cheques are available for refund.',
		noChequeDeposit: 'No Cheque Deposit Currently Exist',
		refundCashTitle: 'Request Refund by Cash',
		refundCashSubHeader: 'Total cash available for refund is',
		noCashDeposit: 'No cash available for refund',
		howMuchRefund: 'How much do you want to refund?',
		amountCreditBackTime:
			'Kindly allow 48-72 hours for the amount to be credited back into your account.',
		refundCashInputValidation:
			'Refund amount should be less than or equal "Available Deposit"',
	},
	depositHistory: {
		header: 'My Deposits History',
		subHeader: 'for everything except Properties',
		depositButton: 'My Deposits Dashboard',
		availableDeposit: 'Available deposit',
		availableLimit: 'Available limit',
		summary: 'My Transaction History Summary',
		noSummary: 'You do not have any available deposit',
	},
	propertyDetails: {
		briefInformation: {
			lot: 'Lot',
			bids: 'Bids',
			timeLeft: 'Time Left',
			addToCalender: 'Add to Calendar',
			currentPrice: 'Current Price',
			minIncrement: 'Min. Increment',
			bidNow: 'Bid Now',
			confirmBid: 'Confirm Bid',
			availableLimit: 'Available Limit',
			addLimit: 'You need to add Deposit Limit for this type.',
			signIn: 'Sign In to place a bid.',
			termsAgreement:
				'I agree to Terms and Conditions & I have inspected the item',
			autoBid: 'Auto Bid',
			errors: {
				exceedLimit: "You don't have enough limit to bid",
				belowMinBidValue: 'Value should exceed the minimum Bid value',
				notMultiplesMinIncreasing:
					'The increasing value should be multiples of minimum increasing value',
			},
		},
		specifications: {
			specifications: 'SPECIFICATIONS',
			type: 'Type',
			area: 'Plot Area',
			bedrooms: 'Bedrooms',
			bathroms: 'Bathrooms',
			carPark: 'Car Park',
			rentedTill: 'Rented Till',
			rentValue: 'Rent Value',
			rentClaimable: 'Rent Claimable',
			study: 'Study',
			storageRoom: 'Storge Room',
			familyArea: 'Family Area',
			maidRoom: 'Maid Room',
		},
	},

	bidStatusMessages: {
		yourBidOf: 'Your Bid of',
		isLeading: 'is currently leading',
		someoneAddHigher: 'You added a bid and someone added a higher bid',
	},
};
